import React from 'react';

const ControlsPanel = () => {
  return (
    <div className="controls-panel">
      {/* Info text only - buttons moved to TopBar */}
      <div style={{ textAlign: 'center', fontSize: '13px', color: '#6b7280' }}>
        <p style={{ margin: '0 0 4px 0' }}>
          💡 Tip: use HTTPS or http://localhost for microphone access.
        </p>
        <p style={{ fontSize: '11px', margin: 0 }}>
          ⚠️ The OpenAI API has rate limits. On a 429 error, wait a few seconds before resuming.
        </p>
      </div>
    </div>
  );
};

export default ControlsPanel;